import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardListPaymentsRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import type { HorizonAppRouteShouldRevalidateFunctionArgs } from '#/routing/types/HorizonAppRouteShouldRevalidateFunctionArgs';

import { OrgDashboardPaymentsListContainerLoadable } from './OrgDashboardPaymentsListContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

// Don't revalidate when search params change, as they won't influence this loader
export function shouldRevalidate(
  _: HorizonAppRouteShouldRevalidateFunctionArgs<
    typeof orgDashboardListPaymentsRoute
  >,
) {
  return false;
}

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardListPaymentsRoute>,
) {
  await OrgDashboardPaymentsListContainerLoadable.load();
}

export default function OrgDashboardListPaymentsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Payments')}>
      <OrgDashboardPaymentsListContainerLoadable />
    </RouteModule>
  );
}
